import { useEffect, useRef, useState } from "react";
import { Base_Url } from "../API/config";

const useEventSSE = (eventId) => {
  const [data, setData] = useState(null);
  const eventSourceRef = useRef(null);

  useEffect(() => {
    if (!eventId) return;
    const url = `${Base_Url}/api/admin-event-information?id=${eventId}&stream=1`;
    const connect = () => {
      if (eventSourceRef.current) return;
      const es = new EventSource(url);
      es.onmessage = (event) => {
        try {
          const parsed = JSON.parse(event.data);

          if (parsed?.data) {
            setData(parsed.data);
          }
        } catch (err) {
          console.error("SSE parse error", err);
        }
      };
      es.onerror = () => {
        es.close();
        eventSourceRef.current = null;
        // reconnect after delay
        setTimeout(connect, 3000);
      };
      eventSourceRef.current = es;
    };
    connect();
    return () => {
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
        eventSourceRef.current = null;
      }
    };
  }, [eventId]);
  return data;
};
export default useEventSSE;